module.exports = __webpack_public_path__ + "img/check-circle.86e837de.svg";